import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGIN_SAP_DELETAR_BEGIN,
  LOGIN_SAP_DELETAR_SUCCESS,
  LOGIN_SAP_DELETAR_FAILURE,
  LOGIN_SAP_DELETAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function deletar(registro) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGIN_SAP_DELETAR_BEGIN,
    data: registro,
  };
}

export function dismissDeletarError() {
  return {
    type: LOGIN_SAP_DELETAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGIN_SAP_DELETAR_BEGIN actions
export function* doDeletar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const LoginSAPApi = new Services['LoginSAPApi']();
    let resApi = yield LoginSAPApi.deleteById(action.data.id);
    if (resApi.count > 0) {
      res = action.data;
    } else {
      throw new Error('Falha ao excluir registro');
    }
  } catch (err) {
    yield put({
      type: LOGIN_SAP_DELETAR_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGIN_SAP_DELETAR_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchDeletar() {
  yield takeLatest(LOGIN_SAP_DELETAR_BEGIN, doDeletar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_DELETAR_BEGIN:
      return {
        ...state,
        deletarPending: true,
        deletarError: null,
      };

    case LOGIN_SAP_DELETAR_SUCCESS:
      return {
        ...state,
        listaLoginSap: state.listaLoginSap.filter(registro => registro.id !== action.data.id),
        deletarPending: false,
        deletarError: null,
      };

    case LOGIN_SAP_DELETAR_FAILURE:
      return {
        ...state,
        deletarPending: false,
        deletarError: action.data.error,
      };

    case LOGIN_SAP_DELETAR_DISMISS_ERROR:
      return {
        ...state,
        deletarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/deletar.js